<fin-loyalty-view [pageTitle]="pageTitle$ | async" [showPlusCard]="true" [showAnnouncementCard]="true">
  <fcom-plus-card class="dn-laptop-up center ms-large-b"></fcom-plus-card>

  <fin-announcement-card class="dn-laptop-up block center ms-large-b"></fin-announcement-card>

  <div data-award-and-tier-points-expand>
    <ng-container *ngIf="isMobile$ | async; else awardAndTierPoints">
      <button
        class="fill flex flex--space-between ps-xsmall-y font-body-1 bold-type"
        [attr.id]="'award-and-tier-points-expand-button'"
        [attr.aria-controls]="'award-and-tier-points-expand-content'"
        [attr.aria-expanded]="awardAndTierPointsExpandOpen"
        (click)="awardAndTierPointsExpandOpen = !awardAndTierPointsExpandOpen"
      >
        {{ 'LOYALTY.pointsAndTransactions.awardAndTierPointsExpandButton' | finLocalization }}
        <fcom-icon
          class="flex--nogrow rotate"
          [class.rotate-active]="awardAndTierPointsExpandOpen"
          [name]="SvgLibraryIcon.CHEVRON_DOWN"
        ></fcom-icon>
      </button>

      <fcom-expand
        class="block"
        [open]="awardAndTierPointsExpandOpen"
        [ariaId]="'award-and-tier-points-expand-content'"
        [ariaLabelledBy]="'award-and-tier-points-expand-button'"
      >
        <div class="mr-large-t ps-xsmall-y">
          <ng-container *ngTemplateOutlet="awardAndTierPoints"></ng-container>
        </div>
      </fcom-expand>
    </ng-container>

    <ng-template #awardAndTierPoints>
      <div class="award-and-tier-points-container flex">
        <div class="z1 flex--basis-full">
          <fin-points-balance (ctaClicked)="scrollToPoints()"></fin-points-balance>
        </div>
        <div class="z1 flex--basis-full">
          <fin-tier-progress />
        </div>
      </div>
    </ng-template>
  </div>

  <fin-avios-linking-and-exchange
    class="mr-large-t"
    *ngIf="!(profile$ | async)?.isJuniorMember ?? false"
  ></fin-avios-linking-and-exchange>

  <div class="transaction-history-wrap mr-large-t">
    <h2 class="nordic-blue-900-text font-heading-2 mr-small-b">
      {{ 'plus.transactionHistory.title' | finLocalization }}
    </h2>

    <fin-transaction-history
      [hiddenCaptionText]="'plus.transactionHistory.title' | finLocalization"
      [hideTooltip]="true"
    ></fin-transaction-history>
  </div>
</fin-loyalty-view>

<div #usePointsContent tabindex="-1">
  <fin-promotion-segment [fragmentUrl]="'LOYALTY.fragments.awardAndTierPoints.url'"></fin-promotion-segment>
  <fin-promotion-segment
    [invertedColors]="true"
    [fragmentUrl]="'LOYALTY.fragments.usePoints.url'"
  ></fin-promotion-segment>
  <fin-promotion-segment [fragmentUrl]="'LOYALTY.fragments.managePoints.url'"></fin-promotion-segment>
</div>
